import { Box, Theme, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import { useTemplate } from "containers/templateDetail/store";
import * as React from "react";

const OptionButton = styled("div")(({ theme }) => ({
  border: "1px solid",
  borderRadius: theme.spacing(2),
  borderColor: theme.palette.grey[300],
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
  marginTop: theme.spacing(1),
  marginRight: theme.spacing(1),
  minWidth: 60,
  textAlign: "center",
  cursor: "pointer",
  "&:hover": {
    // boxShadow: "0 1px 5px 0 rgba(90,90,90,.5)",
    borderColor: theme.palette.grey[800],
  },
}));

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    // "&:before": {
    //   boxShadow: "0 0px 3px 0 rgb(90 90 90 / 50%)",
    // },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 4px 16px 0px rgb(90 90 90 / 50%)",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    color: theme.palette.text.primary,
    maxWidth: 350,
    // boxShadow: theme.shadows[1],
  },
}));

const SizeGuideWrap = styled("ul")(() => ({
  margin: 0,
  padding: 0,
}));

const SizeGuideItem = styled("li")(() => ({
  display: "inline",
  fontSize: "12px",
  wordBreak: "break-word",
  color: "inherit",
}));

const SizeGuideValue = styled("span")(
  ({ isLast = false, theme }: { isLast: boolean; theme: Theme }) => ({
    color: theme.palette.text.secondary,
    // "&:after": {
    //   content: `${isLast ? '"."' : '","'}`,
    // },
  })
);

const SizeTooltip = ({ value, children }) => {
  const { sizes: templateSizes } = useTemplate();

  const activeTempalteSize = React.useMemo(() => {
    return templateSizes.find((item) => item.option_id === value.id);
  }, [value, templateSizes]);

  const sizeGuideDOM = React.useMemo(() => {
    return activeTempalteSize?.attributes?.map((item, index) => {
      return (
        <SizeGuideItem key={index}>
          {item.name}:{" "}
          <SizeGuideValue>
            {item.inch_value} inch
            {index !== activeTempalteSize.attributes.length - 1
              ? ","
              : "."}{" "}
          </SizeGuideValue>
        </SizeGuideItem>
      );
    });
  }, [activeTempalteSize]);

  if (!activeTempalteSize) {
    return children;
  }

  return (
    <CustomTooltip
      title={
        <React.Fragment>
          <Typography color="inherit" variant="subtitle2">
            Product Measurement
          </Typography>
          <SizeGuideWrap>{sizeGuideDOM}</SizeGuideWrap>
        </React.Fragment>
      }
      arrow={true}
      placement="top-start"
    >
      {children}
    </CustomTooltip>
  );
};

export default function DefaultOption({
  option,
}: {
  option: any;
}): React.ReactElement {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", mt: -0.5 }}>
      {option.values.map((value, index) => {
        return (
          <SizeTooltip key={index} value={value}>
            <OptionButton>{value.value}</OptionButton>
          </SizeTooltip>
        );
      })}
    </Box>
  );
}
